// @flow

import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { get } from 'js-cookie';
import type { ContextRouter } from 'react-router-dom';

type Props = ContextRouter & {
  children: (locale: string) => any,
};

class LocaleCode extends PureComponent<Props> {
  getCookieLocaleCode() {
    return get('simpalsid.lang');
  }

  getLocationLocaleCode() {
    return this.props.location.pathname.split('/')[1];
  }

  getRedirectUrl() {
    let redirectUrl;

    const cookieLocaleCode = this.getCookieLocaleCode();
    const locationLocaleCode = this.getLocationLocaleCode();

    // Redirect to corresponding locale code url
    if (
      cookieLocaleCode &&
      locationLocaleCode &&
      locationLocaleCode !== cookieLocaleCode
    ) {
      redirectUrl = window.location.href.replace(
        `/${locationLocaleCode}/`,
        `/${cookieLocaleCode}/`,
      );
    }

    return redirectUrl;
  }

  render() {
    const redirectUrl = this.getRedirectUrl();
    const localeCode = this.getLocationLocaleCode();

    if (redirectUrl) {
      window.location = redirectUrl;
      return null;
    }

    return this.props.children(localeCode);
  }
}

export default withRouter(LocaleCode);
